export default ["info", "info-gray", "success", "warning", "error", "attention"];
